module.exports = __webpack_public_path__ + "img/469d32e.svg";